export default {"src":"/_next/static/media/nrdrealestate__logo--white.2a174311.svg","height":191,"width":475,"blurWidth":0,"blurHeight":0};